<template>
  <div class="ws-multi-list">
    <slot name="top-btns"></slot>
    <div
      v-for="(valueItem,valueIndex) in value"
      :key="valueIndex"
    >
      <WsCard 
        class="ws-multi-list__card mb-4"
        :class="valueItem.bgColor"
      >
        <div :class="valueItem.textColor">
          <v-icon left>{{valueItem[iconControlKey] ? icon : subIcon}}</v-icon>
          {{valueItem[textKey]}}
        </div>

      </WsCard>
      <div
        class="ws-multi-list__inner-list mb-4"
        v-for="(fieldItem,fieldIndex) in layerFields"
        :key="fieldIndex"
      >
        <template v-if="fieldItem.innerFields&&(valueItem[fieldItem.modelKey]&&valueItem[fieldItem.modelKey].length)">
          <WsMultiList
            :value="valueItem[fieldItem.modelKey]"
            :layerFields="layerFields"
            :icon="layerFields[0].icon"
            :iconControlKey="layerFields[0].iconControlKey"
            :subIcon="layerFields[0].subIcon"
          ></WsMultiList>
        </template>
        <template v-else>
          <WsCard
            class="ws-multi-list__card"
            v-for="(cardItem,cardIndex) in valueItem[fieldItem.modelKey]"
            :key="cardIndex"
          >
            <div>
              <v-icon left>{{fieldItem.icon}}</v-icon>
              {{cardItem[fieldItem.textKey]}}
            </div>

          </WsCard>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "WsMultiList",
  methods: {},
  computed: {},
  props: {
    value: {
      type: Array,
    },
    layerFields: {
      type: Array,
    },
    textKey: {
      type: String,
      default: "name",
    },
    icon: {
      type: String,
    },
    subIcon: {
      type: String,
    },
    iconControlKey: {
      type: String,
    }
  },
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/ws-multi-list.scss";
</style>